import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

// The one place dayjs plugins are registered for the web app. Time-zone maths
// never goes through dayjs (no timezone plugin): use
// @compass/shared/utils/zonedTime (PRTL-1512).
dayjs.extend(utc);

export type { Dayjs } from "dayjs";
export default dayjs;
